import {Button} from '@/components/common-components/v2/Button';
import {Select, Slider, Menu, TimePicker} from 'antd';
import styled from 'styled-components';

const {Option} = Select;

export const TimePickerStyled = styled(TimePicker)`
  border-radius: 6px;
  min-width: 80px;
  @media screen and (min-width: 1024px) {
    max-width: 90px;
  }
  @media screen and (max-width: 830px) {
    width: 23%;
  }
  @media screen and (max-width: 700px) {
    width: 48%;
  }
`;

export const ContentContainer = styled.div<{isPublic: boolean}>`
  height: calc(100vh - 65px);
  background: #1F2125;
  padding: ${p => p?.isPublic ? '0 0 0 15px' : '15px 0 0 15px'};
  @media screen and (max-width: 830px) {
    padding-left: 0 !important;
    overflow-y: scroll !important;
  }
      .gm-bundled-control-on-bottom{
  position: absolute !important;
  bottom: 0 !important;
  margin-bottom: 120px !important;
}
`;

export const StyledShareMenu = styled(Menu)`
border-radius: 8px;
.copyTooltip {
  :global(.ant-tooltip-content) {
    background-color: $color-gray-dark;
    border-radius: 10px !important;
  }

  :global(.ant-tooltip-arrow) {
    display: none !important;
  }

  :global(.ant-tooltip-inner) {
    border-radius: 10px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 13px;
  margin: 18px 0 14px 0;
`;

export const ButtonStyled = styled(Button)<{background?: string; textColor?: string; loading?: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
  width: fit-content;
  height: 38px;
  padding: ${p => p?.loading ? '7px 10px' : '7px 20px'};
  border-radius: 8px;
  background: ${p => p?.background ? p?.background : 'rgba(45, 108, 202, 0.25)'};
  color: ${p => p?.textColor ? p?.textColor : '#2D6CCA'};

  &:hover {
    background: linear-gradient(0deg,rgba(0,0,0,0.18),rgba(0,0,0,0.18)),${p => p?.background ? p?.background : 'rgba(45, 108, 202, 0.25)'} !important;
    color: ${p => p?.textColor ? p?.textColor : '#2D6CCA'};
  }
  &:focus {
    background: linear-gradient(0deg,rgba(0,0,0,0.18),rgba(0,0,0,0.18)),${p => p?.background ? p?.background : 'rgba(45, 108, 202, 0.25)'} !important;
    color: ${p => p?.textColor ? p?.textColor : '#2D6CCA'};
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  border-top-left-radius: 10px;
  @media screen and (max-width: 830px) {
    display: flex;
    flex-direction: column;
    background-color: #fff;
  }
`;

export const ResultsWrapper = styled.div<{expanded?: boolean}>`
  position: absolute;
  width: 355px;

  margin-left: 37px;
  margin-top: 54px;

  border-radius: 12px;
  border: 1px solid #E8E8E8;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);

  top: ${p => !p?.expanded ? '72px' : '200px'};
  transition: top 0.4s ease;
  left: -11px;
  padding: 22px 22px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      background: #4E5156;
    }
  }
  @media screen and (max-width: 830px) {
    width: 100%;
    margin-left: 0;
    bottom: 0;
    top: auto;
    position: static;
    margin-top: 0;
    overflow: unset;
    order: -2;
    border: none;
    border-bottom: 1px solid #E8E8E8;
    border-radius: 0;
    box-shadow: none;
  }
`;

export const AddKeywords = styled.p`
  margin: 10px;
  color: rgb(45, 108, 202);
  font-weight: 500;
  cursor: pointer;
`;

export const ScanReportWrapper = styled.div<{collapsed?: boolean}>`
  position: absolute;
  width: 369px;

  margin-top: 54px;
  margin-right: 20px;

  border-radius: 12px;
  border: 1px solid #E8E8E8;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);

  top: 0;
  right: 0;
  padding: 22px 22px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      background: #4E5156;
    }
  }
  .spinIcon{
    font-size: 12px;
    margin: -4px 2px 0 2px;
  }
  .scanCollapseBtn {
    outline: none;
    border: none;
    background-color: #fff;
    font-size: 14px;
    align-self: flex-start;
    cursor: pointer;
  }
  ${p => p?.collapsed ? `
    padding: 0 !important;
    width: fit-content !important;
    *:not(.scanCollapseBtn):not(.scanCollapseBtn *):not(.scanCollapseBtnWrapper) {
      display: none !important;
    }
    .scanCollapseBtn {
      padding: 10px 15px;
    }
  ` : ''}
  @media screen and (max-width: 830px) {
    width: 100%;
    margin-right: 0;
    position: static;
    margin-top: 0;
    overflow: unset;
    order: -1;
    border: none;
    border-radius: 0;
  }
  box-shadow: none;
`;

export const BackButtonSection = styled.div`
  position: absolute;
  width: 355px;

  margin-left: 37px;

  top: 0;
  left: 0;
  padding-top: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #4E5156;
  gap: 5px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      background: #4E5156;
    }
  }
  @media screen and (max-width: 830px) {
    margin-left: 0;
    padding: 15px 10px 0;
    width: 100%;
    position: static;
    margin-top: 0;
    overflow: unset;
    order: -3;
    border: none;
    border-radius: 0;
  }
`;
export const WhiteOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100vh - 65px);
  border-top-left-radius: 12px;
  background: linear-gradient(171deg, rgba(242, 242, 245, 0.95) 7.59%, rgba(255, 255, 255, 0.00) 32.52%);
  top: 0;
  left: 0;
  padding-top: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #4E5156;
  gap: 5px;
  overflow: auto;
  pointer-events: none;

  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      background: #4E5156;
    }
  }
  @media screen and (max-width: 830px) {
    display: none;
  }
`;
export const NoLocationWhiteOverlay = styled.div`
  position: absolute;
  width: auto;
  height: 25px;
  background: #eecaca;
  border-radius: 10px;
  top: calc(50% - (25px / 2));
  left: calc(50% - (154px / 2));
  padding: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      background: #4E5156;
    }
  }
`;

export const MapContainer = styled.div`
  height: 100%;
  width: 100%;
  contain: content;
  border-top-left-radius: 12px;
  .gmnoprint[data-control-height="81"] {
      right: 55px !important;
      bottom: 150px !important;
    }
  @media screen and (max-width: 830px) {
    min-height: 90vh;
  }
`;

export const FailedBanner = styled.div`
  background-color: rgb(254 226 226);
  padding: 10px;
  border-radius: 5px;
  color: rgb(127 29 29);
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MenuStyled = styled(Menu)`
  max-height: 300px !important;
  border-radius: 7px;
  overflow: auto !important;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      background: rgba(78, 81, 86, 0.6);
    }
  }
  .ant-dropdown-menu-item{
    border-radius: 10px;
    margin: 0 10px;
  }
  .ant-dropdown-menu-item-only-child:hover{
  background-color: transparent;
  }
`;

export const CompareDatesBtn = styled.div<{disabled: boolean}>`
  position: relative;
  width: fit-content;
  color: ${p => p?.disabled ? 'rgba(45, 108, 202, 0.5)' : 'rgba(45, 108, 202, 1)'};
  font-size: 12px;
  cursor: pointer;
`;

export const MenuKeywordName = styled.div`
  max-width: 262px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const DropdownDiv = styled.div`
  width: fit-content;
  max-width: 100%;
  height: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 10px 6px 10px;
  border-radius: 6px;
  border: 1px solid #CDCDCD;
  background: #FFFFFF;
`;

export const Arrows = styled.div<{disabled?: boolean}>`
  width: 28px;
  height: 28px;
  display: flex;
  padding: 9px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px solid #CDCDCD;
  opacity: ${p => p?.disabled ? 0.3 : 1};
  background: #FFFFFF;
  cursor: ${p => p?.disabled ? 'not-allowed' : 'pointer'};

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;

export const SliderStyled = styled(Slider)<{disabled?: boolean}>`
  margin: 5px 0 5px 0 !important;
  .ant-slider-track {
    background-color: transparent !important;
  }
  .ant-slider-rail {
    background-color: #2D6CCA !important;
    opacity: ${p => p?.disabled ? 0.1 : 0.3};
  }
  .ant-slider-handle {
    width: 16px !important;
    height: 16px !important;
    border: solid 5px #2D6CCA !important;
    opacity: ${p => p?.disabled ? 0.3 : 1};
  }
`;

export const StyledSelects = styled(Select)<{background?: string; selectType?: string}>`
  ${p => p?.selectType == 'gridShape' && 'width: 135px !important;'}
  ${p => p?.selectType == 'gridDimensions' && 'width: 215px !important;'}
  ${p => p?.selectType == 'miles' && 'width: 123px !important;'}
  ${p => p?.selectType == 'frequency' && 'width: 160px !important;'}
  @media screen and (max-width: 830px) {
    width: 23% !important;
  }
  @media screen and (max-width: 700px) {
    width: 48% !important;
  }
 /* width: -webkit-fill-available; */
 height: fit-content;
 .ant-select-selector {
    background: ${p=> p?.background} !important;
    border-radius: 6px !important;
    border-color: 1px solid #E8E8E8 !important;
    padding: 6px 15px !important;
    height: 44px !important;
    cursor: pointer !important;
    line-height: unset !important;
  ${p => p?.selectType == 'gridShape' && 'width: 135px !important;'}
  ${p => p?.selectType == 'gridDimensions' && 'width: 215px !important;'}
  }
  .ant-select-selection-search {
    padding: 6px 0;
  }
`;
export const StyledOption = styled(Option)`
background: red;
`;

export const DivWrapper = styled.div<{isSelected?: boolean; isLast?: boolean}>`
display: flex;
    justify-content: space-between;
    width: ${props=> props.isLast ? '152px' : '122px'};
    align-items: center !important;
    p{
      margin-bottom: 0px;
      background-color: ${props=> props?.isSelected ? 'rgb(45, 108, 202, 0.2)' : ''} !important;
      padding: 3px 15px;
      border-radius: 8px;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    span:hover{
      path{
        fill: red;
      }
    }
    svg {
      padding: 5px;
      fill: red;
  }
`;
